import React from "react";
import { Redirect, Route } from "react-router-dom";
import DashboardLayout from "./MainLayout";
import user from "src/store/userDetails";
import Page401 from "src/views/errors/Page401";

const AppRoutes = ({
  component: Component,
  path,
  listRoles,
  isPrivate,
  exact,
  ...rest
}) => {
  return (
    <Route
      exact={true}
      path={path}
      render={(props) =>
        isPrivate && !Boolean(user.token) ? (
          <Redirect to={{ pathname: "/login" }} />
        ) : isPrivate ? (
          listRoles.includes(user.rol) ? (
            <DashboardLayout>
              <Component {...props} />
            </DashboardLayout>
          ) : (
            <Page401 />
          )
        ) : (
          <Component {...props} />
        )
      }
      {...rest}
    />
  );
};

export default AppRoutes;
